import { styled } from '@linaria/react';

import { SubHeadline, Title } from '~components/Typography';
import { ButtonIconGhost } from '~shared/ui/atoms/Buttons/ButtonGhost/Icon';

export const StyledBotWizard = styled.div`
	display: flex;
	min-height: 100%;
	flex-direction: column;
`;
export const HeaderWrapper = styled.div`
	width: 100%;
	max-width: 648px;
	padding: 1rem 1.2rem 0.8rem;
	margin-right: auto;
	margin-left: auto;
`;
export const Description = styled(SubHeadline)`
	padding-bottom: 4rem;
`;

export const BackButton = styled(ButtonIconGhost)`
	position: absolute;
	top: 50%;
	left: 0;
	transform: translateY(-50%);
`;
export const HeaderStepsWrapper = styled.div`
	display: flex;
	gap: var(--gap-m);
`;

export const StyledTitle = styled(Title)`
	position: relative;
	padding: 0 4rem;
`;

export const ErrorWrapper = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: var(--gap-x5);
`;

export const StepWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	align-items: center;
	padding-bottom: 120px;
	gap: var(--gap-x10);
`;
